<div class="rc-chart">
  <canvas #canvasElement id="canvas"></canvas>
</div>
